import { Component, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from './../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  DataStateChangeEventArgs, IFilter, SearchSettingsModel, SelectionSettingsModel, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { Observable } from 'rxjs';
import { FileUploaderService } from './../../../services/file-uploader-service';
import { MysqlService } from './../../../services/mysql.service';
import { BsModalService, TabsetComponent } from 'ngx-bootstrap';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { SystemLog } from 'src/app/shared/models/sysLog.model';
import { Brand } from 'src/app/api/brand';
import { ppsDistrHubActionList } from 'src/app/shared/models/ppsDistroHubActionList.model';
import { DataService } from 'src/app/admin/system-log-manager/data.service';

// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';

@Component({
  selector: 'app-action-list-widget',
  templateUrl: './action-list-widget.component.html',
  styleUrls: ['./action-list-widget.component.scss'],
  providers: [DataService]
})
export class ActionListWidgetComponent implements OnInit {


 // set this in the parent
//  doSomethingGhild() {
//   this.refreshGrid();
// }
// set this in the parent
// add this to the drectives directives: [WooActionsGridWidgetComponent] // child component name
    // @ViewChild(WooActionsGridWidgetComponent) child:WooActionsGridWidgetComponent; // constructor
  /*
  ngAfterViewInit() {
      // child is set
      this.child.doSomethingChild();
    }
    */

    // @ViewChild(ActionsGridWidgetComponent) child:ActionsGridWidgetComponent;


  @Input() sent_data?: any; // not used

  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions: FilterSettingsModel;
  public filterOptions_2022: FilterSettingsModel;
  public formatOptions: Object;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[] | object;

  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('grid2') public grid2: GridComponent;
  @ViewChild('grid3') public grid3: GridComponent;
  // public grid: GridComponent;
  public searchOptions: SearchSettingsModel;

  public groupOptions: GroupSettingsModel;
  // public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;


  //checkbox selection options
  public selectionOptions: SelectionSettingsModel;
  public wrapSettings: TextWrapSettingsModel; // { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both



     // setup as observable?
     @Input() item_id?: Observable<any[]>; // impliments on changes.
     @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full

       // TABS sets the selected
  @ViewChild('staticTabs') staticTabs!: TabsetComponent;
  selected_tab?: number;


  subjects_urgent: any;
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };
  // today = new Date();
  initialPage: { pageSize: number; };
  open_jobs_count: any;
  myobCustomers: Object;
  arrCase: object[];
  Items: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  myob_tax_codes_live: Object;
  myob_tax_codes: Object;
  created_myob_tax_account: Object;
  updated_myob_tax_account: Object;
  sessionUserName: string;
  sessionUserLevel: number;
  sessionUserFullName: string;
  sessionUserFirstName: string;
  action_lists: any;
  action_lists_table: any;
  action_list: any;
  action_list_removed: any;

  isShow: any;
  modalRef: any;

  // @Input() action_list_id?: Observable<any[]>; // impliments on changes.
  @Input() action_list_id?: any; // impliments on changes.
  search_results_meta: any;

  search_results_meta_array: any[];
  WebHookAPI_OrderLabelCreateDefaultBulk_response: any;
  action_list_type_id: number;


  woo_page: number; 
request_query: {
      context?: string;
      page?: number;
      per_page?: number;
      search?: string;
      after?: string;
      before?: string;
      exclude?: Array<any>;
      include?: Array<any>;
      offset?: number;
      // order?: ProductOrder;
      // orderby?: ProductOrderBy | string;
      orderby?: any;
    
      parent?: Array<string>;
      parent_exclude?: Array<string>;
      slug?: string;
      status?: string;
      type?: string;
      sku?: string;
      featured?: boolean;
      category?: string;
      tag?: string;
      shipping_class?: string;
      attribute?: string;
      attribute_term?: string;
      tax_class?: string;
      in_stock?: boolean;
      on_sale?: boolean;
      min_price?: string;
      max_price?: string;
      post__in?;
      action_list_id?;
      log_id_array?;
  }

  public page_collection = [];
  woo_orders: any;

  @Output('refreshChildGrid') refreshChildGrid:EventEmitter<any> 
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  woo_per_page: number;


  urlSafe: SafeResourceUrl;
  interval;
  productSlug: string;
  params: object = {}
  woo_ppsactions: any;
  woo_ppsactions_count: any;
  woo_ppsactionsBulkLabels: any;
  woo_ppsactions_count_bulk_labels: any;
  woo_ppsactionsPickList: any;
  woo_ppsactions_count_picklist: any;
  DialogObj: any;
  woo_orders_update: any;
  woo_orders__update_count: any;
  WebHookAPI_PickPackSend_WC_page_update_response: Object;
  WebHookAPI_PickPackSend_WC_page_update_status_response: Object;



  combo_model: Brand;
  search_model: SystemLog;
  brands_client: any;
  brands_agent: any;
  users: Object;
  brand_types: any;
  user_levels: any;
  system_log_types: any;
  model: any;
  sent_model: ppsDistrHubActionList;
  selectedrecords: object[];

  today = new Date().toISOString(); // this date worked to compare dates with ZISo date format in database.
  today_name_file = this.datepipe.transform(this.today, 'dd-MM-yyyy-hhmmss'); // formats date for comparison
  action_day = this.datepipe.transform(this.today, 'ddMMyyyy'); // formats date for comparison
  action_day_words = this.datepipe.transform(this.today, 'EEEEMMMd-y'); // formats date for comparison

  chosenActionListID: any;
  get_latest_action_ist_id: any;
  action_list_today: Object;
  action_list_today_ID: any;
  logs_search: any;
  search_results_meta_START: any[];
    // Need to create a different type of data service?
  // see: https://ej2.syncfusion.com/angular/documentation/grid/observables/
  public dataStateChange(state: DataStateChangeEventArgs): void {
    this.service.execute(state);
  }

// ... additions for datepicker column for sycfusion grid
  //public data: Object[];
  //public ddldata: Object[];
  //public pageOptions: Object;
  public category: string[];
  //public templateOptionsDate: IFilterUI;
  //public elem1: HTMLElement;
  //public datePickerObj: DatePicker;

  // maps the appropriate column to fields property
// public fields: Object = { text: 'Game', value: 'Id' };
public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' }; // using the name field not id!
client_fields: Object = { text: 'user_full_name', value: 'user_id' };
  search_results: any;



  // Mimucs the lower components counts
         // toggle elements
        //  isShow = true;
         isShow_chart1 = false;
         isShow_chart2 = true;

         isShow_chart1_meta = false;
         isShow_chart2_meta = true;

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     public service: DataService,
    //  private orderService: WoocommerceOrderService,
     public sanitizer: DomSanitizer, // https://stackblitz.com/edit/angular-iframe-src-ae7kkf?file=src%2Fapp%2Fapp.component.ts
    //  private woocommerce: WordpressService, 
  ) {   

    // Set and Access login Session Variables
    this.gfunc.setLoginSessionVars(); // set in a global function file
    this.sessionUserId = this.gfunc.currentUserVAR.user_id;
    this.sessionUsername = this.gfunc.currentUserVAR.username;
    this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

          // So set session vars manually. PPS Distro Hub - No Loging Required
          // this.sessionUserId = 142;
          // this.sessionUsername = 'temperosystems';
          // this.sessionUserName = 'temperosystems';
          // this.sessionBrandId = 125;
          // this.sessionUserLevel = 1000;
          // this.sessionUserFullName = 'tempero user';
          // this.sessionUserFirstName = 'tempero';    
    
        // need to add this as routes does not work globally
        this.all_router_details = this.router.url;
        this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
       
       // this.action_list_id = +this.route.snapshot.paramMap.get('action_list_id');
    

          // Grid Options
          // this.toolbarOptions = [];
          // Setup Grid
          // this.toolbarOptions = ['ExcelExport', 'Search', { text: ' >: Filter Agents For Update Request',
          // tooltipText: 'Submit Data to Send Agent Notifications', prefixIcon: 'e-test', id: 'Click'  }
          // ];
          // this.toolbar = [
          // { text: 'Agent Update Request', tooltipText: 'Click', prefixIcon: 'e-expand', id: 'Click' }];

          this.toolbarOptions = ['Search'];

          this.initialPage = { pageSize: 2500 };
          this.filterOptions = {
          type: 'Menu'
          };

          // this.groupOptions = { columns: ['id'] }; // sets auto grouping for the grid
          this.groupOptions = { }; // sets auto grouping for the grid

          this.formatoptions = {type: 'date', format: 'dd/MM/yyyy'};
          this.dateFormat = 'dd/MM/yyyy hh:mm a';
          // this.filter = { params: { format: this.dateFormat } };
          // this.sortOptions = { columns: [ ] };

          //checkbox selection options
          // this.selectionOptions = { checkboxMode: 'ResetOnRowClick'}; // type: 'Multiple', mode: 'Both
          // this.selectionOptions = { type: 'Multiple', mode: 'Both'}; // 
          // this.selectionOptions = { }; // 


          this.searchOptions = {  };
          // this.grid.searchSettings.key = '';
          this.wrapSettings = { wrapMode: 'Content' };

    

          // c3 charts setup testing



          
       }
    
       // check for changes. to load data.
       ngOnChanges(changes) {

        this.woo_page = 1; // sets the default page to load is one
        this.woo_per_page = 100;
      
        if(this.woo_page == 1){
          this.request_query = {
            // page: this.woo_page + 1,
            page: this.woo_page,
            orderby: "id",
            per_page: this.woo_per_page,
            // per_page: 10 // gets the number of rec
            }; 
        }else{
          this.request_query = {
            page: this.woo_page,
            orderby: "id",
            per_page: this.woo_per_page,
            // per_page: 10 // gets the number of rec
            }; 
        }

        // Load the Actions related to the action list
// this.getWooPPSActionsMetaActionID('', this.action_list_id, '38' ); // Bulk Prints Only

/// dont know if this is required or not?
        if(!this.action_list_id || this.action_list == '' ){
          this.action_list_id = +this.route.snapshot.paramMap.get('action_list_id');
        }

        if (changes.item_id) {
          // deal with asynchronous Observable result
          this.item_id = changes.item_id.currentValue;
        }


        if (changes.action_list_id) {
          // deal with asynchronous Observable result
          // this.getJob(this.job_id);
        console.log('On changes Sent Action List Id:' + this.action_list_id);

        this.action_list_id = changes.action_list_id.currentValue;
        this.getActionList(this.action_list_id);


        
        }


      }

      
  ngOnInit() {
    console.log('Oninit: Sent Action List Id:' + this.action_list_id);
    this.search_model = new SystemLog(); // if undefined need to setup the model first.
    this.getSystemLogTypes();

    // this.getLogsSearch(this.search_model)
    this.getBrandsComboBoxClients(this.combo_model); // gets all brands
    this.getUsers();
    this.getBrandTypes();
    this.getFormUserLevels();
    this.getSystemLogTypes();


// Load the Actions related to the action list
// this.getWooPPSActionsMetaActionID('', this.action_list_id, '38' ); // Bulk Prints Only - variables do not work. - made more spefic calls below uses these



    // set a LOOP REFRESH for the action list.
                  // this.interval = setInterval(() => { 
                  //   // this.woo_orders= [];
                  //   this.getActionList(this.action_list_id);
                    
                  //  }, 130000);

    // this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.gfunc.brand_wordpress_URL + '/wp-admin/post.php?post=19351&action=edit&embedded=true');


    if(!this.action_list_id || this.action_list == '' ){
     this.action_list_id = +this.route.snapshot.paramMap.get('action_list_id');
     this.getActionList(this.action_list_id);

      // load the Actions created print lists and bulk labels
    //  this.getWooPPSActionsMetaActionIDBulkLabels('', this.action_list_id);
    //  this.getWooPPSActionsMetaActionIDPickList('', this.action_list_id);

     this.woo_page = 1; // sets the default page to load is one
     this.woo_per_page = 100;
   
     if(this.woo_page == 1){
       this.request_query = {
         // page: this.woo_page + 1,
         page: this.woo_page,
         orderby: "id",
         per_page: this.woo_per_page,
         // per_page: 10 // gets the number of rec
         }; 
     }else{
       this.request_query = {
         page: this.woo_page,
         orderby: "id",
         per_page: this.woo_per_page,
         // per_page: 10 // gets the number of rec
         }; 
     }
   







    }

             
      // Grid Options
            //   this.toolbarOptions = ['ExcelExport', 'Search'];
            //   this.initialPage = { pageSize:5 };
            //   this.filterOptions = {
            //      type: 'Menu'
            //   };
            //  // this.groupOptions = { columns: [''] }; // sets auto grouping for the grid
            //   this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
            //   this.dateFormat = 'dd/MM/yyyy hh:mm a';
            //   this.filter = { params: { format: this.dateFormat } };
            //  // this.sortOptions = { columns: [{ field: 'job_id', direction: 'Descending' } ] };
          
          
          // end date filter options
              // End Grid Options
      }

    
    





// Still using will rename and rebild later
      wooPageCollectionArray(woo_page){
        // if (confirm('Please confirm your Action List has been saved first., we have to gather another 100 orders.')) {
        
        // set by loading the search_results in the grid
      // let action_list =  JSON.stringify(this.search_results_meta_array) // this was giving incorrect counts missing the first one... below fixes the issue. April 2023
      let action_list =  this.search_results_meta_array 

      // console.log('Action List: ' + action_list);
      
        this.request_query = {
          page: woo_page,
          orderby: "id",
          per_page: this.woo_per_page,
          // addition of arrays
          // include: ['1949','19349','19332','19320'], // this does not work.
          // include: [Array('19351', '19349', '19332', '19320')], // this is the correct way to send an array to wordpress!!
          include: [Array(action_list)], // this is the correct way to send an array to wordpress!!
          log_id_array: Array(action_list), // this is the correct way to send an array to wordpress!!
      

        }
        this.woo_page = woo_page; // need to set the new page
        // this.getWooOrders(this.request_query);


        // added search
        // this.request_query = this.search_results;

        this.getSystemLogsArray(this.request_query);


      // }


      }




    // request_query
    getWooOrders(request_query){
  //     if(this.grid){this.grid.showSpinner();}
  // this.orderService.listAllOrders(request_query)
  // .subscribe(response => {
  //   console.log(response);
  //   this.woo_orders = response
  //  // this.refreshGrid();
  //  if(this.grid){this.grid.hideSpinner();}
  // }, (err) => {
  //   console.log('ngx:woo:error ', err);
  // });
}


getSystemLogsArray(request_array) {
  this._demoService.getSystemLogsArray(request_array).subscribe(
     data => { this.woo_orders = data;
      let res = data[0];

      // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
      // // console.log(this.arrCase);
      // this.Items = data['Items'] ;
      // this.sent_data = this.Items;
      // this.sent_data = this.myob_account_codes;

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



  /// TABS
  selectTab(tab_id: number) {
    this.staticTabs.tabs[tab_id].active = true;
    this.selected_tab = tab_id; // so that we can load the queries only when the tabs clicked
  };


    
      // :: Grid Functions
    
    
    // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
    clickHandler(args: ClickEventArgs): void {
      if (args.item.id === 'Click') {
    
      //  this.grid.showSpinner();
    
      //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
     //  console.log(args.data.items);
     
    
    
      let pdfdata;
      const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
      for (let i = 0; i < query.queries.length; i++) {
        if (query.queries[i].fn === 'onPage') {
          query.queries.splice(i, 1);       // remove page query to get all records
          break;
        }
      }
      const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
        pdfdata = e.result as object[];  // get all filtered records
        const exportProperties = {
          dataSource: pdfdata,
        };
        // console.log(pdfdata.results);
    
       // this.search_results = pdfdata.records; // need this if a grouping is set.
      /*   this.search_results = pdfdata;
        this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
        this.toastr.success( "Press Start To Process Que");  */
       // this.grid.pdfExport(exportProperties);
      }).catch((e) => true);
      }
    
     //  this.grid.hideSpinner();
    
    };
    
    
    toolbarClick(args: ClickEventArgs): void {
      if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
          this.grid.excelExport();
      }
    }
    rowDataBound(args:any) {
      const status = 'status';
      if (args.row.status ===  'completed') {
          // args.row.className = 'strikethrough text-primary';
          // args.row.classList.add('strikethrough');
          args.row.className = 'strikethrough text-muted';
          args.row.classList.add('below-80');

      }
    }
    
      // :: Grid Functions






      public getMyobTaxCodesLive() {
        return  this._demoService.getMyobTaxCodesLive().subscribe(
            data => { this.myob_tax_codes_live = data;
              const res = data[0];
               // https://www.concretepage.com/questions/577
               this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
               // console.log(this.arrCase);
               this.Items = data['Items'] ;
               this.sent_data = this.Items;
      
               // console.log(this.Items);
              // this.Address = this.Items['Address'];
        // return this.myobCustomers;
      
        // Map the data top the new model system
       // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));
      
            },
            err => {
              // this.toastr.error('You need to login to MYOB again, Connection lost!');
             // console.error(err);
            },
            // () => console.log('done loading Trace Types')
          );
      
        }
  

        getMyobTaxCodes() {
          this._demoService.getMyobTaxCodes().subscribe(
             data => { this.myob_tax_codes = data;
              let res = data[0];
      
              // this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
              // // console.log(this.arrCase);
              // this.Items = data['Items'] ;
              // this.sent_data = this.Items;
              // this.sent_data = this.myob_account_codes;
      
            },
             err => console.error(err),
             // () => console.log('done loading Trace Types')
           );
         }


         refreshGrid(){ // refresh the databutton
          // this.loadList(this.doc_id);
          // this.getMyobTaxCodesLive();
          this.getActionLists();
        //  this.grid.refresh();
        };




        createMyobTaxCodesImport(model) {

          let TaxCollectedAccount;
          let TaxPaidAccount;

          if (typeof model.TaxCollectedAccount === 'undefined' || model.TaxCollectedAccount === null ) {
            TaxCollectedAccount = null;
          }else {
            TaxCollectedAccount = model.TaxCollectedAccount.UID; // can only call if actuall exist in the array!
          };

          if (typeof model.TaxPaidAccount === 'undefined' || model.TaxPaidAccount === null ) {
            TaxPaidAccount = null;
          }else {
            TaxPaidAccount = model.TaxPaidAccount.UID;
          };
      
          let new_model = null;
          // :: Build New model
          new_model = {
            myob_tax_code_name: model.Code,
            myob_tax_code_code: model.Code,
            myob_tax_id: model.UID,
            tax_percentage: model.Rate,
            UID: model.UID,
            Code: model.Code,
            Description: model.Description,
            Type: model.Type,
            Rate: model.Rate,
            IsRateNegative: model.IsRateNegative,
            TaxCollectedAccountUID: TaxCollectedAccount,
            TaxPaidAccountUID: TaxPaidAccount,
            LastModified: model.LastModified,
            RowVersion: model.RowVersion,
            myob_array: JSON.stringify(model)
          }; // multidimentional array push
      
      // run an external function to check the vaule - does not run before function not working
      // const check_val =  this.checkForLocalMyobAccountUID(model.UID);
      // console.log('Checked Value: ' + JSON.stringify(check_val));
      
      // lookup myob accounts row with UID = local UID then filter  and count the rows. then access array for variables.
      // tslint:disable-next-line:max-line-length
      const localTaxAccountsLInkedArr = Object(this.myob_tax_codes).filter((ac) => (ac.UID === model.UID)); // filter array of already looked up myob_account_codes data
      console.log('LocalCheckCount: ' + localTaxAccountsLInkedArr.length );
      const local_account_check_length = localTaxAccountsLInkedArr.length;
      
                  if (local_account_check_length === null || local_account_check_length === 0) {
                    console.log('We need to create this one.');
                        this._demoService.createMyobTaxCodes(new_model).subscribe(
                          data => {   this.created_myob_tax_account = data; // this is the retuned json upon creation.
                            //  let res = data[0];
                        this.toastr.success('Tax Code Created Locally');
                        // return true;
                          },
                          error => {
                            console.error(error);
                          });
      
                  } else {
                    console.log('We need to UPDATE this one');
                            const local_myob_tax_code_id = localTaxAccountsLInkedArr[0].myob_tax_code_id;
                            this._demoService.updateMyobTaxCodes(new_model, local_myob_tax_code_id).subscribe(
                              data => {   this.updated_myob_tax_account = data; // this is the retuned json upon creation.
                                //  let res = data[0];
                            this.toastr.success('Tax Code Imported and Updated');
                            //  return true;
                              },
                              error => {
                                console.error(error);
                              });
      
                  }
      this.getMyobTaxCodes(); // need to refresh the loop model for next press otherwise does not know of updates to myob_account_codes
         };







         toggleShow(index) {
          // this.isShowEdit = ! this.isShowEdit;
         // if (this.isShow === index){
         // this.isShow = '';
         // }else{
         //   this.isShow = index; // sets to the array row.d
         // }
         this.isShow = index; // sets to the array row.d
         
           }
         
           toggleHide(index) {
          // this.isShowEdit = ! this.isShowEdit;
         // if (this.isShow === index){
         // this.isShow = '';
         // }else{
         //   this.isShow = index; // sets to the array row.d
         // }
         this.isShow = index; // sets to the array row.d
         
           }
         
         
         
          // MODAL
         // start of modal windows service as a template
         openModal(template: TemplateRef<any>) {
           // small upgrade to disable background click on open modal background
           const config = { backdrop: true, ignoreBackdropClick: true, class: 'blue modal-lg' };
           this.modalRef = this.modalService.show(template, config);
         }
         
         
         
         // :: Parent / Child modal test
         closeParentModel2() {
          //  alert('parent component function.');
            this.modalRef.hide();
         // now refresh the invoice items list from the new items.
             // empty your array first
             // this.invoiceItemsList.length = 0;
            //  this.workOrderItemsList.length = 0;
            //  this.getSubjectCostItems(this.subject_id);
         
         
          // this.closeParentModel.emit(); // ?shuts invoice window
          // this.refreshGrid(); // resets the grid if updated and closed.
         //  this.updateTypeClick = false; // closes the div
         };
         
         
         // :: Parent / Child modal test
         closeParentModel3() {
           //  alert('parent component function.');
             this.modalRef.hide();
          };







         getActionLists() {
          this._demoService.getActionLists().subscribe(
            data => {
              this.action_lists = data;
              this.action_lists_table = this.action_lists.slice(0, 10);
            },
            error => {
               this.toastr.error( "Sorry, we were not able to get the lists");
              //  console.error('Error Loading User!');
              // return Observable.throw(error);
            }
          );
        }


        getActionList(action_list_id){
          this._demoService.getActionList(action_list_id)
          // .pipe(
          //   this.toastr.observe({
          //     loading: '... monkey working ...',
          //     success: '🚀',
          //     error: '-'
          //  })
          //  )
          .subscribe(
            res => {
              
              this.action_list = res;
              let data = res[0];
              // this.search_results_meta = this.action_list[0].search_results_meta;
              // now need to loop through and build an object array
              this.action_list_type_id = data.action_list_type_id;

              this.search_results_meta = []; // set the empty object first.
              // this.search_results_meta_array = []; // set the empty object first.
              // :: Impliments automatic recipients based on chosen com template options (Moved and recoded into a seeperate function)
              let newArr = JSON.parse(this.action_list[0].search_results_meta);
              // let  count_of_items = newArr.length;
              let  count_of_items = Object.keys(newArr).length;

              let  count_of_items2 = this.action_list[0].search_results_meta.length;

              console.log('Count of Meta Items: ' + count_of_items)
              console.log('Count of Meta Items2: ' + count_of_items)

            console.log('Count of search items: ' + count_of_items);
                // need to do a loop of subject_billing items (.length)
                for (let i = 0; i < count_of_items; i++) {
                let res2 = newArr[i];
                this.search_results_meta.push({
                ...newArr[i]
                });

                // set the array to just have id's to get real data.
                // this.search_results_meta_array.push({
                //   id: newArr[i].id,
                // });

                } // end for loop

                this.search_results_meta_START = this.search_results_meta; // ?? this may be causing err
                this.search_results_meta = this.search_results_meta; // ?? this may be causing errors.
              // this.search_results_meta_array = this.search_results_meta_array; // ?? this may be causing errors.

            

              this.search_results_meta_array = this.search_results_meta.map(function (system_log) {
                // return order.id
                return system_log.log_id
              });


              // This sends the array of IDS to a function to get the rsults and push to the data to
              this.wooPageCollectionArray(this.woo_page);
              
              

              // console.log('search results meta: ' + this.search_results_meta);

            // this.refreshGrid();
            this.grid3.refresh();


            },
            err => {
            this.toastr.error( "Sorry, we were not able to get the list");
              console.error(err.status);
                    }
          );
         }


         // must get the meta gain.
         getActionList_REFRESH(action_list_id){
          this._demoService.getActionList(action_list_id)
          // .pipe(
          //   this.toastr.observe({
          //     loading: '... monkey working ...',
          //     success: '🚀',
          //     error: '-'
          //  })
          //  )
          .subscribe(
            res => {
              
              this.action_list = res;
              let data = res[0];
              // this.search_results_meta = this.action_list[0].search_results_meta;
              // now need to loop through and build an object array
              this.action_list_type_id = data.action_list_type_id;

              this.search_results_meta = []; // set the empty object first.
              // this.search_results_meta_array = []; // set the empty object first.
              // :: Impliments automatic recipients based on chosen com template options (Moved and recoded into a seeperate function)
              let newArr = JSON.parse(this.action_list[0].search_results_meta);
              // let  count_of_items = newArr.length;
              let  count_of_items = Object.keys(newArr).length;

              let  count_of_items2 = this.action_list[0].search_results_meta.length;

              console.log('Count of Meta Items: ' + count_of_items)
              console.log('Count of Meta Items2: ' + count_of_items)

            console.log('Count of search items: ' + count_of_items);
                // need to do a loop of subject_billing items (.length)
                for (let i = 0; i < count_of_items; i++) {
                let res2 = newArr[i];
                this.search_results_meta.push({
                ...newArr[i]
                });

                // set the array to just have id's to get real data.
                // this.search_results_meta_array.push({
                //   id: newArr[i].id,
                // });

                } // end for loop

              this.search_results_meta = this.search_results_meta; // ?? this may be causing errors.
              // this.search_results_meta_array = this.search_results_meta_array; // ?? this may be causing errors.

            

              this.search_results_meta_array = this.search_results_meta.map(function (system_log) {
                // return order.id
                return system_log.log_id
              });


              // This sends the array of IDS to a function to get the rsults and push to the data to
              // this.wooPageCollectionArray(this.woo_page); -- this will refresh everything. and set base. -- entire route.
              // console.log('search results meta: ' + this.search_results_meta);

            this.grid3.refresh();
            },
            err => {
            this.toastr.error( "Sorry, we were not able to get the list");
              console.error(err.status);
                    }
          );
         }
        

         deleteActionList(action_list_id){
        if (confirm('Are you sure you wish to delete this action list? ID=' + action_list_id)) {
          this._demoService.deleteActionList(action_list_id).subscribe(
            res => {this.action_list_removed = res;
              this.toastr.success( "Done, action list removed.");
           
          //  this.gfunc.globalppsDistroHubOrdersViewSkipRoute(); // load the orders page to sart the process over again
              this.refreshGrid();
            },
            err => {
            this.toastr.error( "Sorry, we were not able to delete the list");
              console.error(err.status);
              }
          );
                  }// end confirm
         }


      //    WebHookAPI_OrderLabelCreateDefaultBulk(model, order_id, doc_id){
      //     // this gets set and overridden in the route interceptor
      //     let  new_model = {
      //       'username' : 'api_user',
      //       'password' : '1234xyz',
      //       'action_list_id' : this.action_list_id,
      //       'action_list_type_id' : this.action_list_type_id,
      //       ...model, // send the entire model. - new 2023 Template System DistroHub Beta
      //       'search_results_meta_array': this.search_results_meta_array,
      //         }; // use this model for defaul testing and setup variables required and added. 

      //     this._mysqlService.WebHookAPI_OrderLabelCreateDefaultBulk(new_model, order_id, doc_id)
      //     .pipe(
      //       this.toastr.observe({
      //         loading: '... monkey working ...',
      //         success: '🚀',
      //         error: '😡'
      //      })
      //      )
      //     .subscribe(
      //       data => {  this.WebHookAPI_OrderLabelCreateDefaultBulk_response = data;
      //         // refresh the invoice:
      //         this.toastr.success('B.I.N.G.O - We created the Bulk Action for you!');
      //     //    this.gfunc.globalppsDistroHubOrderViewSkipRoute(order_id); // now refresh the page

      //     //    this.gfunc.globalppsDistroHubOrderViewSkipRoute(order_id); // now refresh the page
      // // load the Actions created print lists and bulk labels
      // this.getWooPPSActionsMetaActionIDBulkLabels('', this.action_list_id);
      // this.getWooPPSActionsMetaActionIDPickList('', this.action_list_id);
      //     // this.child.doSomethingChild();
      //     // this.gfunc.globalppsViewActionListSkipRoute(this.action_list_id); // now refresh the page
      //     // Do this litte trick to reload the observable in inlcuded module in HTML page without the complications. -jist change the id and change it back and see what happens.
              

      
    
      //       },
      //       error => {
      //        // console.error('Error saving Event!');
      //         // this.toastr.error('computer says no!, sorry try again, label not created this time.');
      //         this.toastr.success('B.I.N.G.O - We created the Bulk Action for you!');
      //     //    this.gfunc.globalppsDistroHubOrderViewSkipRoute(order_id); // now refresh the page

      //     //    this.gfunc.globalppsDistroHubOrderViewSkipRoute(order_id); // now refresh the page
      // // load the Actions created print lists and bulk labels
      // this.getWooPPSActionsMetaActionIDBulkLabels('', this.action_list_id);
      // this.getWooPPSActionsMetaActionIDPickList('', this.action_list_id);


      //     // this.child.doSomethingChild();
      //         return console.error(error);
              
      //       }
      //      // err => console.error(err),
      //      //
      //     )};




    //       WebHookAPI_OrderPickListDefault(model, order_id, doc_id){
    //         // this gets set and overridden in the route interceptor
    //         let  new_model = {
    //           'username' : 'api_user',
    //           'password' : '1234xyz',
    //           'action_list_id' : this.action_list_id,
    //           'action_list_type_id' : this.action_list_type_id,
    //           ...model, // send the entire model. - new 2023 Template System DistroHub Beta
    //           'search_results_meta_array': this.search_results_meta_array,
    //             }; // use this model for defaul testing and setup variables required and added. 
    //             // error: '😡'
    //         this._mysqlService.WebHookAPI_OrderPickListDefault(new_model, order_id, doc_id)
    //         .pipe(
    //           this.toastr.observe({
    //             loading: '... monkey working ...',
    //             success: '🚀',
    //             error: '-'
    //          })
    //          )
    //         .subscribe(
    //           data => {  this.WebHookAPI_OrderLabelCreateDefaultBulk_response = data;
    //             // refresh the invoice:
    //             this.toastr.success('B.I.N.G.O - We created the Pick List for you!');
    //         //    this.gfunc.globalppsDistroHubOrderViewSkipRoute(order_id); // now refresh the page


    //             // load the Actions created print lists and bulk labels
    //  this.getWooPPSActionsMetaActionIDBulkLabels('', this.action_list_id);
    //  this.getWooPPSActionsMetaActionIDPickList('', this.action_list_id);
            
    //       // this.child.doSomethingChild();
  
    //           //  this.gfunc.globalppsViewActionListSkipRoute(this.action_list_id); // now refresh the page
        
      
    //           },
    //           error => {
    //            // console.error('Error saving Event!');
    //       // this.child.doSomethingChild();
    //             // this.toastr.error('computer says no!, sorry try again, label not created this time.');

    //             this.toastr.success('B.I.N.G.O - We created the Pick List for you!');
    //         //    this.gfunc.globalppsDistroHubOrderViewSkipRoute(order_id); // now refresh the page


    //             // load the Actions created print lists and bulk labels
    //  this.getWooPPSActionsMetaActionIDBulkLabels('', this.action_list_id);
    //  this.getWooPPSActionsMetaActionIDPickList('', this.action_list_id);

    //             return console.error(error);
    //           }
    //          // err => console.error(err),
    //          //
    //         )};





// Custom WP API quiery
// getWooPPSActionsMetaActionID(request_query, action_list_id, job_type_court_id){
//   this.productSlug =  ''; // just for now so I can get the id later
//   // this.productSlug =  'per_page='+100; // just for now so I can get the id later

//   var meta_query = encodeURIComponent(JSON.stringify({
//     relation: 'AND',
//     0: {
//       key: 'action_list_id',
//       value:'2'
//     },
//     // 1: {
//     //   key: 'dayoweek',
//     //   value: 'saturday'
//     // }
//   }));

//   this.request_query = {
//     page: 1,
//     orderby: "date",
//     per_page: 5,
//     // per_page: 10 // gets the number of rec
// // action_list_type_id: 1,
// // action_list_id: 2, // actually the action list id being sent.
// // job_court_type_id: 38 // actually the action list id being sent.
// // meta_query: meta_query

//     }; 

// // proper way to search via meta data in wp query
//     // 'meta_query'  => array(
//     //   array(
//     //       'key' => 'specials',
//     //       'value' => 'these are not the specials you are looking for - Obi Wan Kenobi'
//     //   )


//   // this.params = {slug:this.productSlug}  
//   this.params = {slug: this.request_query }    
//   // this.params = {slug: request_query }            

            
//   // let wooppsactionsurl:string = this.woocommerce.authenticateApi('GET', this.brand_wordpress_URL + '/wp-json/wp/v2/pps-action', this.request_query);
//   let wooppsactionsurl:string = this.woocommerce.authenticateApi('GET', this.gfunc.brand_wordpress_URL + '/wp-json/wp/v2/custompost','');

//   // let wooproducturl:string = this.woocommerce.authenticateApi('GET',  'products', this.params);
//   // let wooWebhooksurl:string = this.woocommerce.authenticateApi('GET', this.brand_wordpress_URL + '/wp-json/wc/v3/webhooks', this.params);
//   // wc/v3/customers
//   this.http.get(wooppsactionsurl).subscribe((wc_ppsactions_data:any) => { 
  
//     // Filter results
// //           let wc_ppsactions_data_filtered = wc_ppsactions_data.map(function (officer: any) {
// //   return officer.job_type_court_id == 38 || officer.job_type_court_id == 39
// // });
     
//     // job_type_court_id == pick lists or bulk shipping


  
//   this.woo_ppsactions = wc_ppsactions_data;  
//   // this.woo_ppsactions = wc_ppsactions_data_filtered;  
//   this.woo_ppsactions_count = this.woo_ppsactions.length; 

//   // add a filter to return spefic types -- RESULTS DO NOT WORK.
//   // if (job_type_court_id != ''){
//   //   let wc_ppsactions_data_filtered = wc_ppsactions_data.map(function (officer: any) {
//   //   return officer.ppsData[0].job_type_court_id == job_type_court_id
//   //   });

//   //   this.woo_ppsactions = wc_ppsactions_data_filtered;  
//   //   this.woo_ppsactions_count = this.woo_ppsactions.length; 

//   // }



//   // this.product = wc_data[0];  
//   this.params = {}
//   // let productvariationurl:string = this.woocommerce.authenticateApi('GET',this.brand_wordpress_URL + '/shop/wp-json/wc/v2/products/'+this.product.id+'/variations',this.params);
//   // this.http.get(productvariationurl).subscribe((wc_pv_data:any) => {
//   //     this.productVariations = wc_pv_data;
//   });
// }




// getWooPPSActionsMetaActionIDBulkLabels(request_query, action_list_id){
//   this.productSlug =  ''; // just for now so I can get the id later
//   // this.productSlug =  'per_page='+100; // just for now so I can get the id later

//   this.request_query = {
//     page: 1,
//     orderby: "date",
//     per_page: 5,
//     // per_page: 10 // gets the number of rec
//     action_list_id : action_list_id // MUST REQURED NOW.
//     }; 


//   // this.params = {slug:this.productSlug}  
//   this.params = {slug: this.request_query }    
//   // this.params = {slug: request_query }            

            
//   // let wooppsactionsurl:string = this.woocommerce.authenticateApi('GET', this.brand_wordpress_URL + '/wp-json/wp/v2/pps-action', this.request_query);
//   let wooppsactionsurl:string = this.woocommerce.authenticateApi('GET', this.gfunc.brand_wordpress_URL + '/wp-json/wp/v2/ppsActionID/bulk-labels',this.request_query);

//   // let wooproducturl:string = this.woocommerce.authenticateApi('GET',  'products', this.params);
//   // let wooWebhooksurl:string = this.woocommerce.authenticateApi('GET', this.brand_wordpress_URL + '/wp-json/wc/v3/webhooks', this.params);
//   // wc/v3/customers
//   this.http.get(wooppsactionsurl).subscribe((wc_ppsactions_data:any) => { 


  
//   this.woo_ppsactionsBulkLabels = wc_ppsactions_data;  
//   // this.woo_ppsactions = wc_ppsactions_data_filtered;  
//   this.woo_ppsactions_count_bulk_labels = this.woo_ppsactionsBulkLabels.length; 

//   });
// }


// getWooPPSActionsMetaActionIDPickList(request_query, action_list_id){
//   this.productSlug =  ''; // just for now so I can get the id later
//   // this.productSlug =  'per_page='+100; // just for now so I can get the id later

//   this.request_query = {
//     page: 1,
//     orderby: "date",
//     per_page: 5,
//     // per_page: 10 // gets the number of rec
// action_list_id : action_list_id // MUST REQURED NOW.
//     }; 


//   // this.params = {slug:this.productSlug}  
//   this.params = {slug: this.request_query }    
//   // this.params = {slug: request_query }            

            
//   // let wooppsactionsurl:string = this.woocommerce.authenticateApi('GET', this.brand_wordpress_URL + '/wp-json/wp/v2/pps-action', this.request_query);
//   let wooppsactionsurl:string = this.woocommerce.authenticateApi('GET', this.gfunc.brand_wordpress_URL + '/wp-json/wp/v2/ppsActionID/picklist',this.request_query);

//   // let wooproducturl:string = this.woocommerce.authenticateApi('GET',  'products', this.params);
//   // let wooWebhooksurl:string = this.woocommerce.authenticateApi('GET', this.brand_wordpress_URL + '/wp-json/wc/v3/webhooks', this.params);
//   // wc/v3/customers
//   this.http.get(wooppsactionsurl).subscribe((wc_ppsactions_data:any) => { 
  
//   this.woo_ppsactionsPickList = wc_ppsactions_data;  
//   // this.woo_ppsactions = wc_ppsactions_data_filtered;  
//   this.woo_ppsactions_count_picklist = this.woo_ppsactionsPickList.length; 

//   });
// }



// grid search buttons
searchGridColStatus(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  console.log('Packing');
  // clear first
  this.grid.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['status'], operator: 'contains', key: name, ignoreCase: true };
  // now refresh the grid
  this.grid.refresh();
}



// Log Filter
searchGridColLogTypeName(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // console.log('Packing');
  // clear first
  this.grid2.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['log_type_name'], operator: 'contains', key: name, ignoreCase: true };
  // now refresh the grid
  this.grid2.refresh();
}



searchGridColCreatedVia(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['created_via'], operator: 'contains', key: name, ignoreCase: true };
  // now refresh the grid
  this.grid.refresh();
}


searchGridRemaining(string) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['status'], operator: 'contains', key: 'processing', ignoreCase: true };
  // now refresh the grid
  this.grid.refresh();
}

searchGridColTotalAbove(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['total'], operator: 'greaterThanOrEqual', key: '65', ignoreCase: true };
  // now refresh the grid
  this.grid.refresh();
}



searchGridMail(name) {
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['shipping_total'], operator: 'lessThanOrEqual ', key: '.01', ignoreCase: true };
  // now refresh the grid
  this.grid.refresh();
}


searchGridCP(name) {
  this.searchOptions = {  };
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  // const searchText: string = name;
  // this.grid.search(searchText);

  // clear first
  this.grid.searchSettings.key = '';
  // now update the search uptions
  this.searchOptions = { fields: ['shipping_total'], operator: 'greaterThanOrEqual ', key: '1', ignoreCase: true };
  // now refresh the grid
  this.grid.refresh();
}

clearSearchGrid() {
  this.grid2.searchSettings.key = '';
}

searchGrid(name) {
  this.searchOptions = {  };
  this.grid.searchSettings.key = '';
  // const searchText: string = (document.getElementsByClassName('searchtext')[0] as any).value;
  const searchText: string = name;
  this.grid.search(searchText);

}



getSystemLogTypes() {
  this._demoService.getSystemLogTypes().subscribe(
     data2 => { this.system_log_types = data2;
      // console.log(data2);
   },
     err => console.error(err),
     () => console.log('done loading User Levels')
   );
 }



// Display a modal window informing that there are no attachments on send.

onOpenDialogSendComms = function(event: any, model): void {

  // if(this.allAttachments.length <= 0 && this.cancel_clicked != 1){ }// end if.

  this.DialogObj = DialogUtility.confirm({
    title: '<i class="fa fa-magic text-success font-bold pull-left"></i> Let us Setup some things are you ready....! ',
    // tslint:disable-next-line:max-line-length
    content: '<i class="fa fa-check fa-2x text-success font-bold pull-left"></i> <b> By pressing "Continue" ... we will..</p><ol><li>Set Status of Order - Packing</li><li>Automatically Open a New window, Loading the Order in Woo</li><li>And Automatically route to the portal view of this order, ready to pack.</li></ol> ',
    okButton: {  text: '<i class="fa fa-check text-success font-bold pull-left"></i> Continue, and do your stuff.', click: this.okClickSaveSubject.bind(this, model) },
    cancelButton: {  text: '<i class="fa fa-times text-danger font-bold pull-left"></i> Cancel for now', click: this.cancelClickSaveSubject.bind(this, model) },
    showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});

 
}

public okClickSaveSubject(model): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 // this.createJobSubjectsMultiple(this.newSubject);
// this.clientJobSubmission(this.job_id);
// this.cancel_clicked = 0;
// this.click_continue = 1;
// this.sendAgentCommunicationEmail(model);


// this.WebHookAPI_PickPackSend_WC_OrderPageUpdate(model, model.id, '')
           

// This function sets the status to packing... need to update name functions and create a more universal function... push stutus as var.
// this.WebHookAPI_PickPackSend_WC_PageUpdateStatus(model, model.id, '', 'packing') // sets new status to packing.
            // this.openLink_WP_Order_Edit(model.id)
            // this.gfunc.globalppsDistroHubOrderViewSkipRoute(model.id); // now refresh the page

this.DialogObj.hide();
}

public cancelClickSaveSubject(model): void {
   // alert('you clicked Cancel button');
  //  this.cancel_clicked = 1;
  //  this.click_continue = 0;
   this.DialogObj.hide();
}


// Custom page API using now - qpril 2022
// WebHookAPI_PickPackSend_WC_OrderPageUpdate(model, order_id, doc_id){
//   // if (confirm('Please confirm this will change the status of this order to picking...')) {
//   // this gets set and overridden in the route interceptor
//   let  new_model = {
//     'username' : 'api_user',
//     'password' : '1234xyz',
//     // 'action_list_id' : this.action_list_id,
//     // 'action_list_type_id' : this.action_list_type_id,
//     ...model, // send the entire model. - new 2023 Template System DistroHub Beta
//     // 'search_results_meta_array': this.search_results_meta_array,
//     // April 2024 send post data update from form model.
//     'model' : JSON.stringify(model),
//       }; // use this model for defaul testing and setup variables required and added. 
//       // error: '😡'
//   this._mysqlService.WebHookAPI_PickPackSend_WC_OrderPageUpdate(new_model, order_id, doc_id)
//   .pipe(
//     this.toastr.observe({
//       loading: '... monkey working ...',
//       success: '🚀',
//       error: '-'
//    })
//    )
//   .subscribe(
//     data => {  this.WebHookAPI_PickPackSend_WC_page_update_response = data;
//       // refresh the invoice:
//       this.toastr.success('...Order Status Updated.');
     
//       // after update d
//       this.openLink_WP_Order_Edit(model.id)
//       // this.getActionList(this.action_list_id);
//      this.gfunc.globalppsDistroHubOrderViewSkipRoute(order_id); // now refresh the page

//     //  this.gfunc.globalppsViewActionListSkipRoute(this.action_list_id); // now refresh the page

//     },
//     error => {
//      // console.error('Error saving Event!');

//       // this.toastr.error('computer says no!, sorry try again, page not updated.');
//       this.openLink_WP_Order_Edit(model.id)
//       // this.getActionList(this.action_list_id);
//      this.gfunc.globalppsDistroHubOrderViewSkipRoute(order_id); // now refresh the page
//       return console.error(error);
//     }
//    // err => console.error(err),
//    //
//   )
// // };//end if.

// } 



// WebHookAPI_PickPackSend_WC_PageUpdateStatus(model, order_id, doc_id, new_status){
//   if (confirm('Please confirm this will change the status of this order to '+ new_status +'...')) {
//   // this gets set and overridden in the route interceptor
//   let  new_model = {
//     'username' : 'api_user',
//     'password' : '1234xyz',
//     // 'action_list_id' : this.action_list_id,
//     // 'action_list_type_id' : this.action_list_type_id,
//     ...model, // send the entire model. - new 2023 Template System DistroHub Beta
//     // 'search_results_meta_array': this.search_results_meta_array,
//     // April 2024 send post data update from form model.
//     'model' : JSON.stringify(model),
//       }; // use this model for defaul testing and setup variables required and added. 
//       // error: '😡'
//   this._mysqlService.WebHookAPI_PickPackSend_WC_PageUpdateStatus(new_model, order_id, doc_id, new_status)
//   .pipe(
//     this.toastr.observe({
//       loading: '... monkey working ...',
//       success: '🚀',
//       error: '-'
//    })
//    )
//   .subscribe(
//     data => {  this.WebHookAPI_PickPackSend_WC_page_update_status_response = data;
//       // refresh the invoice:
//       this.toastr.success('... Status Updated.');
     
//       // after update d
//     //   this.openLink_WP_Order_Edit(model.id)
//     //   // this.getActionList(this.action_list_id);
//     //  this.gfunc.globalppsDistroHubOrderViewSkipRoute(order_id); // now refresh the page

//     //  this.gfunc.globalppsViewActionListSkipRoute(this.action_list_id); // now refresh the page

//     },
//     error => {
//      // console.error('Error saving Event!');

//       this.toastr.error('computer says no!, sorry try again, page not updated.');
//       return console.error(error);
//     }
//    // err => console.error(err),
//    //
//   )
// };//end if.

// } 




openLink_WP_Order_Edit(id){
  // let link = this.gfunc.brand_wordpress_URL + '/wp-admin/post.php?post=' + id + '&action=edit';
  // window.open(link);
}










getBrandsComboBoxClients(combo_model) {
  // this.combo_model.brand_id = 2;
 this._demoService.getBrands().subscribe(
    data => { this.brands_client = data; },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


// getBrandsComboBoxClients(combo_model) {
//   // this.combo_model.brand_id = 2;
//  this._demoService.getBrandsComboBox(combo_model).subscribe(
//     data => { this.brands_client = data; },
//     err => console.error(err),
//     // () => console.log('done loading Trace Types')
//   );
// }

getBrandsComboBoxAgents(combo_model) {
 this.combo_model.brand_id = 3;
this._demoService.getBrandsComboBox(combo_model).subscribe(
   data => { this.brands_agent = data; },
   err => console.error(err),
   // () => console.log('done loading Trace Types')
 );
}




getUsers() {
this._demoService.getUsers().subscribe(
   data => { this.users = data; },
   err => console.error(err),
   () => console.log('done loading users')
 );
}


  // Functions
  getBrandTypes() {
    this._demoService.getBrandBrandTypes().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }

   getBrandTypesNoOwner() {
    this._demoService.getBrandBrandTypesNoOwner().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }


   getFormUserLevels() {
    this._demoService.getFormUserLevels().subscribe(
       data2 => { this.user_levels = data2;
        console.log(data2);
     },
       err => console.error(err),
       () => console.log('done loading User Levels')
     );
   }



   public getLogsSearch(search_model) {
    this.logs_search = [];
    this._demoService.fetchSystemLogSearch(search_model)
    .pipe(
      this.toastr.observe({
        loading: 'Checking...',
        success: '🚀',
        error: '...😡...'
     })
     )
    .subscribe(
      (res) => (
        this.logs_search = res,
        this.woo_orders = this.logs_search, // changes the grid data
        this.grid2.refresh()
        ),
      (err) => console.error(err.status)
    );
  } /* */



  public getLogsSearch_Meta(search_model) {
    
    
    // Need to reset the search results and reload the orgilab meta first
    // this.getActionList_REFRESH(this.action_list_id); // clears and reloads the list to search again.
// this.search_results_meta = this.search_results_meta_START;


    this.logs_search = [];
    // CreatedBy Filter
  this.logs_search = DataUtil.parse.parseJson(search_model); // works for meta pass - not direct orders via mysql?
  // this.graph_data = new DataManager(this.search_results as JSON[]).executeLocal(new Query()); // Sets the grid data for the graphs //.take(100)
  // var group = _.groupBy(this.logs_search, 'log_type_name')


      //   /// THIS CURRENTLY DOES NOTHING... if statemetn
      //  if(this.search_results_meta != '[]'){ // if form values
  let filtered_array = _.filter(this.search_results_meta_START, 
    // { 'created_by': search_model.created_by, 'active': true }
    { 'created_by': search_model.created_by }
);
// Printing the output 
// console.log(filtered_array);
 
this.search_results_meta = filtered_array;
this.grid3.refresh();
 

      // }else{
      //   this.search_results_meta = this.search_results_meta_START; // refresh
      //   this.grid3.refresh();
      // } // end if search model.



// Need to apply filters on the data and return using javascript typescript or loadash

    // this._demoService.fetchSystemLogSearch(search_model)
    // .pipe(
    //   this.toastr.observe({
    //     loading: 'Checking...',
    //     success: '🚀',
    //     error: '...😡...'
    //  })
    //  )
    // .subscribe(
    //   (res) => (
    //     this.logs_search = res,
    //     this.woo_orders = this.logs_search, // changes the grid data
    //     this.grid2.refresh()
    //     ),
    //   (err) => console.error(err.status)
    // );
  } /* */

}
